export default __webpack_public_path__ + "static/media/wish-color.44099936.svg";